import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const LifestyleContext = React.createContext();

export const useLifestyleContext = () => useContext(LifestyleContext);

export function LifestyleProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/c661aca6-c5fa-427d-9d82-9e620589f5a6').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/a2eff785-3863-4215-be9d-843cef80f6c0')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/e1eb503c-0d83-4efb-8cfa-502660d0d534').then(setArticles);

    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, videos, articles]
  );

  return <LifestyleContext.Provider value={value}>{children}</LifestyleContext.Provider>;
}
